export default "__VITE_ASSET__BGJMMv9U__"